module.exports = __webpack_public_path__ + "static/media/picture-(251).ae9d09aa.JPG";